import React,{ useEffect} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography, Button, Divider } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import {DialogTitle, TextField } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
const useStyles = makeStyles(() => ({
  root: {}
}));

const AddPrice = props => {
  const { className, ...rest } = props;
  const [open, setOpen] = React.useState(true);
  const [confirmmaxprice, setConfirmmaxprice] = React.useState(false);

  const theme = useTheme();
  const [prevprice, setPrevprice] = React.useState(props.liveobj);

  const [liveobj, setLiveobj] = React.useState(props.liveobj ? props.liveobj : {isRange : false});
  const [error, setError] = React.useState({error: false,
    message: {
      
    }});
  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState('sm');
  const classes = useStyles();
  const handleSave = () => {
    let pricediff = null;
    if(prevprice)
    {
      let oldprice = prevprice.pricefrom + (-1 * prevprice.price_diff);
      let newprice = liveobj.pricefrom
      pricediff = newprice - oldprice;
    }
 
    if(liveobj.isRange && parseFloat(liveobj.price_start) >= parseFloat(liveobj.price_end))
    {
      let errorcontent = {
        error : true,
        message : 
        {
          "price_start":"price_end should be greater than price_from"
        }
        
      }
      setError(errorcontent)
    }else {
      let errorcontent = {
        error : false,
        message : 
        {
        
        }
        
      }
      setError(errorcontent)
    props.onUpdate({...liveobj,
      price_end : liveobj.isRange ? liveobj.price_end : null,
      pricediff})
     }
  };
  const handlecheck = () => {
    let isexceedlimit = false;
    let price_from_max = parseFloat(prevprice.price_start) + (parseFloat(prevprice.price_start) * 0.05);
    let price_from_min = parseFloat(prevprice.price_start) - (parseFloat(prevprice.price_start) * 0.05);
    if(price_from_max > 0 && parseFloat(liveobj.price_start)  > parseFloat(price_from_max)  )
    {
      isexceedlimit = true;
    }

    if(price_from_min > 0 && parseFloat(liveobj.price_start)  < parseFloat(price_from_min)  )
    {
      isexceedlimit = true;
    }
        if(liveobj.isRange)
        {
          let price_to_max = parseFloat(prevprice.price_end) + (parseFloat(prevprice.price_end) * 0.05);
          let price_to_min = parseFloat(prevprice.price_end) - (parseFloat(prevprice.price_end) * 0.05);
          if(price_to_max > 0 && parseFloat(liveobj.price_end) > parseFloat(price_to_max))
          {
            isexceedlimit = true;
          }

          if(price_to_min > 0 && parseFloat(liveobj.price_end) < parseFloat(price_to_min))
          {
            isexceedlimit = true;
          }
        }
        if(isexceedlimit)
        {
         setConfirmmaxprice(true)
        }else
        {
          handleSave()
        }
  }
  const toggleChecked = type =>  (e) => {
    setLiveobj({
      ...liveobj,
      [type]: e.target.checked
    })
    if(type === 'isRange')
    {
      if(!e.target.checked)
      {
        setLiveobj({
          ...liveobj,
          isRange : false,
          priceto: ""
        })
      }
    }
    
  };

  
  const handleinputchange = type => e => {
    if(type == "price_end")
    {
      console.log("================",liveobj.price_start)
      console.log("=========YYYYYYY",liveobj.price_start)
      if(parseInt(liveobj.price_start) >= parseInt(e.target.value))
      {
        console.log("================XXXXXX",e.target.value)

      let errorcontent = {
        error : true,
        message : 
        {
          "price_end":"price_end should be greater than price_from"
        }
        
      }
      setError(errorcontent)
    }else{
      let errorcontent = {
        error : false,
        message : 
        {
          
        }
        
      }
      setError(errorcontent)
    }
    }
    setLiveobj({...liveobj,
      [type] : e.target.value})
  };
  const handleClose = () => {
    setOpen(false);
    props.onDismiss()
  };
  const handleClickConfirm = () => {
    setConfirmmaxprice(false);
    handleSave()
    
  };

  const handleCancel = () => {
    setConfirmmaxprice(false);
  };
  useEffect(() => {
  }, []);
  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
       <Dialog
        open={confirmmaxprice}
        onClose={handleCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
       
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            The price may be mistake please check once again
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button onClick={handleClickConfirm} autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">{liveobj?.live_price_id ? `${liveobj.name} Update Price` : `${liveobj.name} Add Price `}</DialogTitle>
        <Divider />
        <DialogContent>
                  <Grid container spacing={2}>
                  <Grid item xs={12}>
                  <FormControlLabel
                      label="Range"
                      control={<Switch  name="checkedA" color="primary" 
                      checked={liveobj ? liveobj.isRange : false}
                      onChange={toggleChecked('isRange')} />}
                      labelPlacement="start"
                    />
                    </Grid>
                  <Grid item xs={6}>
                       <TextField
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            value={liveobj ? liveobj.price_start : null}
                            autoComplete="off"
                            id="vendordeliverydays"
                            name="vendordeliverydays"
                            onChange={handleinputchange('price_start')}
                            error={error?.message?.price_start}
                            helperText={error?.message?.price_start}
                           label="Price From"
                          />
                          </Grid>
                          <Grid item xs={6}>
                          <TextField
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            disabled={!liveobj.isRange}
                            value={liveobj.isRange ? liveobj ? liveobj.price_end : null : ""}
                            autoComplete="off"
                            id="vendordeliverydays"
                            name="vendordeliverydays"
                            error={error?.message?.price_end}
                           helperText={error?.message?.price_end}
                            onChange={handleinputchange('price_end')}
                           label="Price To"
                          />
                          </Grid>
                          <Grid item xs={12}>
                  <FormControlLabel
                      
                      label="Push Notification"
                      control={<Switch  name="checkedA" color="primary" onChange={toggleChecked('isPush')}/>}
                      labelPlacement="start"
                    />
                    </Grid>
                </Grid>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button  onClick={handleClose} color="default">
            Cancel
          </Button>
          <Button onClick={ handlecheck} variant="contained" color="primary" autoFocus>
            {liveobj?.live_price_id ? "Update" : "Add"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

AddPrice.propTypes = {
  className: PropTypes.string
};

export default AddPrice;
